/* Ordenacao "Maior desconto" (sort_by=discount-desc) - Relaxmedic / tema Focal
   v2-estavel: ordena via CSS order a pagina atual (sem mover nos no DOM) */
(function () {
  var SORT_VALUE = 'discount-desc';
  var SORT_LABEL = 'Maior desconto';
  var runs = 0;

  function isActive() {
    try { return new URLSearchParams(window.location.search).get('sort_by') === SORT_VALUE; }
    catch (e) { return false; }
  }

  function parsePrice(el) {
    if (!el) return null;
    var t = (el.textContent || '').replace(/[^\d.,]/g, '');
    if (!t) return null;
    var n = parseFloat(t.replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function discountOf(item) {
    var p = parsePrice(item.querySelector('.product-item__price--sale, .price--highlight'));
    var c = parsePrice(item.querySelector('.product-item__price--compare, .price--compare'));
    if (p === null || c === null || c <= p) return -1;
    return (c - p) / c;
  }

  function getItems() {
    var all = Array.prototype.slice.call(document.querySelectorAll('product-list .product-item'));
    if (!all.length) return [];
    var parent = all[0].parentNode;
    return all.filter(function (el) { return el.parentNode === parent; });
  }

  function apply() {
    if (!isActive()) return;
    var items = getItems();
    if (items.length < 2) return;
    var ranked = items.map(function (el, i) { return { el: el, i: i, d: discountOf(el) }; });
    ranked.sort(function (a, b) { return (b.d - a.d) || (a.i - b.i); });
    ranked.forEach(function (r, pos) {
      var v = String(pos + 1);
      if (r.el.style.order !== v) r.el.style.order = v;
    });
    var radio = document.querySelector('input[name="sort_by"][value="' + SORT_VALUE + '"]');
    if (radio && !radio.checked) radio.checked = true;
    var label = document.getElementById('sort-by-selected-value');
    if (label && label.textContent.trim() === '') label.textContent = SORT_LABEL;
  }

  function clearOrders() {
    getItems().forEach(function (el) {
      if (el.style.order) el.style.order = '';
    });
  }

  var t = null;
  function schedule() {
    if (runs > 80) return; /* trava de seguranca absoluta */
    if (t) return;
    t = setTimeout(function () {
      t = null;
      runs++;
      if (isActive()) { apply(); } else { clearOrders(); }
    }, 150);
  }

  function init() {
    schedule();
    var facet = document.querySelector('product-facet');
    var target = facet ? (facet.parentNode || facet) : document.body;
    try {
      new MutationObserver(function () { schedule(); })
        .observe(target, { childList: true, subtree: true });
    } catch (e) {}
    window.addEventListener('popstate', function () { runs = 0; schedule(); });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'sort_by') { runs = 0; schedule(); }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
